/* eslint-disable no-restricted-globals */
import { giftCardStatus } from '@/utils/constant';
import currency from 'currency.js';
import parsePhoneNumber from 'libphonenumber-js';

export const formatPhoneNumber = (value: string) => {
  const phoneNumber = parsePhoneNumber(value ?? '');
  return phoneNumber?.formatNational() ?? 'N/A';
};

export const convertBasePhoneNumber = (value: string) => {
  const phoneNumber = parsePhoneNumber(value ?? '', { defaultCountry: 'US' });
  return phoneNumber?.number;
};

export const formatNational = (phone: string) => {
  try {
    const parsedPhone = parsePhoneNumber(phone, 'US');

    if (parsedPhone?.isValid()) return parsedPhone.formatNational();

    return phone;
  } catch (e) {
    return phone;
  }
};

export const formatNumberToCurrency = (amount: unknown) => {
  let output = Number(amount);
  if (isNaN(output)) output = 0;
  const formatted = currency(output, {
    fromCents: true,
  });
  return formatted.format();
};

export const formatNumber = (number: number) => {
  const formatted = currency(number, { symbol: '' });
  return formatted.format();
};

export const formatGiftCard = (value: string) => {
  if (!value) return '';
  const numbers = value.replace(/[\s-]/g, '');
  return numbers.replace(/(.{4})/g, '$1 ').trim();
};

export const calculateDiscountedPrice = (
  originalPrice: number,
  discountPercent: number,
) => {
  if (discountPercent < 0 || discountPercent > 100) {
    throw new Error('Discount percentage must be between 0 and 100');
  }

  const discountAmount = (originalPrice * discountPercent) / 100;
  const discountedPrice = originalPrice - discountAmount;

  return currency(discountedPrice, {
    fromCents: true,
  }).format();
};

export const calculateDiscountPercent = (
  originalPrice: number,
  discountedPrice: number,
): number => {
  if (
    originalPrice <= 0 ||
    discountedPrice < 0 ||
    discountedPrice >= originalPrice
  )
    return 0;

  const discountPercent =
    ((originalPrice * 100 - discountedPrice * 100) / originalPrice) * 100;

  return Math.floor(discountPercent) / 100;
};

export const calculatePercentChange = (
  current: number | null | undefined,
  previous: number | null | undefined,
) => {
  const currentValue = current ?? 0;
  const previousValue = previous ?? 0;

  // Avoid division by zero
  if (previousValue === 0) {
    return currentValue > 0 ? 100 : 0;
  }

  return ((currentValue - previousValue) / previousValue) * 100;
};

export const formatCode = (value: string): string => {
  if (!value) return '';
  const cleaned = value.replace(/[\s-]/g, '');
  return cleaned.replace(/(.{4})(?=.)/g, '$1-');
};

export const convertStatus = (status: string) => {
  if (!status) return '';
  if (status === giftCardStatus.INITIAL) return 'Not sold yet';
  if (status === giftCardStatus.INACTIVE) return 'Inactive';
  if (status === giftCardStatus.ACTIVE) return 'Active';
  if (status === giftCardStatus.USED_UP) return 'Used up';
  return '';
};

export const convertToUTC = (date: Date) => {
  const getDate = date.getUTCDate();
  const getMonth = date.getUTCMonth() + 1;
  const getYear = date.getUTCFullYear();
  const getHours = date.getUTCHours();
  const getMinutes = date.getUTCMinutes();
  const getSeconds = date.getUTCSeconds();
  return `${getYear}-${getMonth}-${getDate} ${getHours}:${getMinutes}:${getSeconds}`;
};
